module.exports = __webpack_public_path__ + "img/section-1.4c726645.png";